export default "__VITE_ASSET__707ac1b4__"